import React from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import Toolbar from "@material-ui/core/Toolbar";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import NestedList from "../../partials/content/NestedList";

const drawerWidth = 190;
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
  },
  drawer: {
    [theme.breakpoints.up("sm")]: {
      width: drawerWidth,
      flexShrink: 0,
      marginLeft: "-25px",
    },
  },
  appBar: {
    position: "unset",
    alignItems: "center",
    background: "transparent",
    boxShadow: "none",
  },
  menuButton: {
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    [theme.breakpoints.up("md")]: {
      marginLeft: "25px",
      borderRadius: "4px 0 0 4px",
    },
    [theme.breakpoints.down("sm")]: {
      marginLeft: "15px",
      borderRadius: "4px 0 0 4px",
      maxHeight: "calc( 100vh - 207.5px ) !important",
    },
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    [theme.breakpoints.up("sm")]: {
      paddingLeft: drawerWidth,
    },
  },
}));

const ListLayout = (
  { component, listMenu, onSelectItem, defaultSelected },
  props
) => {
  const { window } = props;
  const classes = useStyles();
  const theme = useTheme();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <div>
      <NestedList
        lists={listMenu}
        onSelectItem={onSelectItem}
        defaultSelected={defaultSelected}
      />
    </div>
  );

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <React.Fragment>
      <div className={classes.root}>
        <CssBaseline />
        <Hidden smUp implementation="css">
          <AppBar className={classes.appBar}>
            <Toolbar>
              <button
                type="button"
                onClick={handleDrawerToggle}
                className={`btn btn-icon btn-label-brand btn-md btn-pill btn-bold ${classes.menuButton}`}
              >
                <i className="fas fa-bars"></i>
              </button>
            </Toolbar>
          </AppBar>
        </Hidden>
        <nav className={classes.drawer}>
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Hidden smUp implementation="css">
            <Drawer
              container={container}
              variant="temporary"
              anchor={theme.direction === "rtl" ? "right" : "left"}
              open={mobileOpen}
              onClose={handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper,
              }}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
            >
              {drawer}
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation="css">
            <Drawer
              classes={{
                paper: classes.drawerPaper,
              }}
              variant="permanent"
              open
            >
              {drawer}
            </Drawer>
          </Hidden>
        </nav>
        <main className={classes.content}>{component}</main>
      </div>
    </React.Fragment>
  );
};

export default ListLayout;
